import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=744bcb8f&scoped=true"
import script from "./AnswerList.vue?vue&type=script&lang=js"
export * from "./AnswerList.vue?vue&type=script&lang=js"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=744bcb8f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bcb8f",
  null
  
)

export default component.exports